
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/application",
      function () {
        return require("private-next-pages/application.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/application"])
      });
    }
  